import type { BridgeMcpToolCallResult, BridgeMcpToolContext } from '../../bridge-mcp-tool-types.js';
import { mcpTextResult } from '../session-history/fork/mcp-text-result.js';
import { fetchCloudIntegrationContent } from './cloud/fetch-integration-content.js';
import { formatIntegrationContentForMcp } from './format-integration-content-for-mcp.js';
import { GET_INTEGRATION_CONTENT_TOOL } from './tool-names.js';

export async function callIntegrationContentMcpTool(
  ctx: BridgeMcpToolContext,
  cloud: { cloudApiBaseUrl: string; getCloudAccessToken: () => string },
  name: string,
  args: Record<string, unknown>,
): Promise<BridgeMcpToolCallResult> {
  if (name !== GET_INTEGRATION_CONTENT_TOOL) {
    return mcpTextResult(`Unknown integration content tool: ${name}`, true);
  }

  const sessionId = ctx.sessionId.trim();
  if (!sessionId) return mcpTextResult('sessionId is required.', true);

  const url = typeof args.url === 'string' ? args.url.trim() : '';
  if (!url) return mcpTextResult('url is required.', true);

  const associateAsSessionTicket = args.associateAsSessionTicket !== false;

  const fetched = await fetchCloudIntegrationContent({
    sessionId,
    url,
    associateAsSessionTicket,
    cloudApiBaseUrl: cloud.cloudApiBaseUrl,
    getCloudAccessToken: cloud.getCloudAccessToken,
  });
  if (!fetched.ok) return mcpTextResult(fetched.error, true);

  const text = formatIntegrationContentForMcp(fetched.data);
  const isError = !fetched.data.ok;
  return mcpTextResult(text, isError);
}
